// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"498":"8b79a4e2","598":"132b0d1c","703":"64dec60c","787":"f7f525a1"}[chunkId] + ".chunk.js";
};